import { IoMdNotificationsOutline } from "react-icons/io";

export function NotificationButton({ hasUnread = false }) {
  return (
    <button
      className="relative p-2 rounded-full hover:bg-gray-200 transition-colors duration-200 text-gray-600"
      aria-label="Notifications"
    >
      <IoMdNotificationsOutline className="w-6 h-6" />

      {hasUnread && (
        <>
          {/* Outer pulsing circle */}
          <span
            className="absolute top-2 right-2 inline-flex h-2.5 w-2.5 rounded-full bg-blue opacity-75 animate-ping"
            style={{ animationDuration: "1.5s" }}
          />

          {/* Inner solid dot */}
          <span className="absolute top-2 right-2 inline-flex h-2.5 w-2.5 rounded-full bg-blue" />
        </>
      )}
    </button>
  );
}
